"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListRow = exports.metaType = void 0;
var React = require("react");
var sok_ui_1 = require("@caddigital/sok-ui");
var components_1 = require("components");
var metaType = function (props, type) {
    var x = props.wizard.types.find(function (x) {
        return x.value === type;
    });
    return x.name;
};
exports.metaType = metaType;
var setOrder = function (props, identifier, order) {
    if (props.step4.schemaId === null) {
        return;
    }
    var metas = Object.values(props.metaMap);
    var oldOrder = props.metaMap[identifier].order;
    var newOrder = oldOrder + (order === 'asc' ? +1 : -1);
    var x = __assign({}, props.metaMap[identifier]);
    x.order = newOrder;
    if (order === 'asc') {
        var y = metas.find(function (m) { return m.order > oldOrder; });
        if (y) {
            y.order = oldOrder;
            props.moveMeta(props.step4.schemaId, [y, x]);
        }
    }
    else {
        var y = metas.reverse().find(function (m) { return m.order < oldOrder; });
        if (y) {
            y.order = oldOrder;
            props.moveMeta(props.step4.schemaId, [y, x]);
        }
    }
};
var ListRow = function (_a) {
    var row = _a.row, props = _a.props, index = _a.index;
    return (React.createElement(sok_ui_1.Table.Row, null,
        React.createElement(sok_ui_1.Table.Column, null, row.name),
        React.createElement(sok_ui_1.Table.Column, null, (0, exports.metaType)(props, row.type)),
        React.createElement(sok_ui_1.Table.Column, null,
            React.createElement(sok_ui_1.Input, { type: 'checkbox', id: 'metadata', value: row.required, disabled: true })),
        React.createElement(sok_ui_1.Table.Column, null,
            React.createElement(sok_ui_1.Input, { type: 'checkbox', id: 'metadata', value: !row.editable, disabled: true })),
        React.createElement(sok_ui_1.Table.Column, null,
            React.createElement(components_1.TableRowIcon, { circle: true, icon: 'fa-pen', className: 'black', onClick: props.toggleEditModal(row.identifier) })),
        React.createElement(sok_ui_1.Table.Column, null,
            React.createElement(components_1.TableRowIcon, { circle: true, icon: row.mandatory ? 'fa-minus' : 'fa-times', className: 'red', onClick: props.step4.schemaId !== null && !row.mandatory
                    ? props.deleteMeta(props.step4.schemaId, row.identifier)
                    : undefined })),
        row.identifier !== 'name-meta' ? (React.createElement(sok_ui_1.Table.Column, null,
            React.createElement(components_1.TableRowIcon, { circle: true, icon: 'fa-chevron-circle-down modal-input-icon', onClick: function () { return setOrder(props, row.identifier, 'asc'); }, disabled: index === Object.keys(props.metaMap).length - 1 ||
                    props.step4.listStatus === 'FETCHING' ||
                    props.step4.editStatus === 'SAVING' }),
            React.createElement(components_1.TableRowIcon, { circle: true, icon: 'fa-chevron-circle-up modal-input-icon', onClick: function () { return setOrder(props, row.identifier, 'desc'); }, disabled: index === 1 ||
                    props.step4.listStatus === 'FETCHING' ||
                    props.step4.editStatus === 'SAVING' }))) : (React.createElement(sok_ui_1.Table.Column, null))));
};
exports.ListRow = ListRow;
